import { Law } from "@/data/laws";
import { ExternalLink, Scale } from "lucide-react";

interface LawCardProps {
  law: Law;
}

const LawCard = ({ law }: LawCardProps) => {
  return (
    <div className="relative h-full bg-card border border-border rounded-3xl p-6 transition-all duration-300 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/5">
      {/* Header */}
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-2">
          <div className="p-2 rounded-3xl bg-primary/10">
            <Scale className="w-4 h-4 text-primary" />
          </div>
          <span className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
            {law.tipo}
          </span>
        </div>
        <ExternalLink className="w-4 h-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>

      {/* Number */}
      <h3 className="text-2xl font-bold text-foreground mb-3">
        Nº {law.numero}
      </h3>

      {/* Ementa */}
      <p className="text-base text-muted-foreground line-clamp-3 mb-4 leading-relaxed">
        {law.ementa}
      </p>

      {/* Footer */}
      <div className="flex items-center justify-between pt-4 border-t border-border mt-auto">
        <span className="text-sm text-muted-foreground">{law.orgao}</span>
        <span className="text-sm font-medium text-primary">{law.data}</span>
      </div>
    </div>
  );
};

export default LawCard;